export default __webpack_public_path__ + "static/media/productHowItWorks1.04e0f134.svg";